import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect, useState } from "react";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import Tooltip from "@mui/material/Tooltip";
import {
    IconButton, Typography, TextField
} from "@mui/material";
import FeedbackIcon from '@mui/icons-material/Feedback';
import { STATUS_RESOLVED, STATUS_CLOSED } from '../../Constants/StatusConstants';
import { VERY_DISSATISFIED, DISSATISFIED, NEUTRAL, SATISFIED, VERY_SATISFIED } from "../../Constants/StatusConstants";
import { FEEDBACK_URL, TICKET_FEEDBACK_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "./../alerts//AlertContext";

function TicketFeedback({ ticketId, status }) {
    const [view, setView] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [open, setOpen] = useState(false);
    const [comments, setComments] = useState("");
    const [feedback, setFeedback] = useState({
        id: '',
        comments: '',
        feedback: '',
        ticket: {}
    });

    useEffect(() => {

    }, []);

    const showAlert = useAlert();

    const handleClickOpen = () => {
        getFeedback();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const smileyOptions = [
        { emoji: "😠", label: "Very Dissatisfied", value: VERY_DISSATISFIED },
        { emoji: "😟", label: "Dissatisfied", value: DISSATISFIED },
        { emoji: "😐", label: "Neutral", value: NEUTRAL },
        { emoji: "🙂", label: "Satisfied", value: SATISFIED },
        { emoji: "😍", label: "Very Satisfied", value: VERY_SATISFIED },
    ];


    const saveFeedback = () => {
        feedback.comments = comments;
        feedback.feedback = selectedValue;
        feedback.ticket = { id: ticketId };
        AxiosInstance.post(FEEDBACK_URL, feedback)
            .then((response) => {
                showAlert("Feedback saved successfully!", "success");

            })
            .catch((error) => {
                alert("Feedback save failed!");
                console.error(error);
            });
    }

    const getFeedback = () => {
        AxiosInstance.get(TICKET_FEEDBACK_URL + ticketId).then(
            (response) => {
                var feedbackData = response.data;
                if (response.data.length > 0) {
                    setComments(feedbackData[0].comments);
                    setSelectedValue(feedbackData[0].feedback);
                    setView(true);
                }
                setOpen(true);
            }
        );
    };

    return (
        <ThemeProvider>
            <React.Fragment>

                <Tooltip
                    title="Feedback"
                    onClick={handleClickOpen}
                    style={{ cursor: "pointer", margin: "2px" }}
                >
                    <IconButton disabled={status !== STATUS_RESOLVED && status !== STATUS_CLOSED}>
                        <FeedbackIcon color={(status !== STATUS_RESOLVED && status !== STATUS_CLOSED) ? "disabled" : "primary"} />
                    </IconButton>
                </Tooltip>

                <Dialog

                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        component: "form",
                        onSubmit: (event) => {
                            event.preventDefault();
                            saveFeedback();
                            setOpen(false);
                        },
                    }}
                >
                    <DialogTitle>Feedback</DialogTitle>
                    <DialogContent>
                        <Box
                            component="form"
                            sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
                            noValidate
                            autoComplete="off"
                        >


                            <Typography variant="h6" gutterBottom>
                                How was your experience?
                            </Typography>

                            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                {smileyOptions.map((option) => (
                                    <IconButton
                                        key={option.value}
                                        onClick={() => setSelectedValue(option.value)}
                                        sx={{
                                            fontSize: "2.5rem",
                                            borderRadius: "50%",
                                            backgroundColor:
                                                selectedValue === option.value ? "#d1e7dd" : "transparent",
                                            border:
                                                selectedValue === option.value
                                                    ? "2px solid #0f5132"
                                                    : "2px solid transparent",
                                            transform:
                                                selectedValue === option.value ? "scale(1.3)" : "scale(1)",
                                            transition: "all 0.2s ease-in-out",
                                        }}
                                        title={option.label}
                                    >
                                        {option.emoji}
                                    </IconButton>
                                ))}
                            </Box>

                            <Box mt={3}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Comments"
                                    value={comments}
                                    onChange={(e) => setComments(e.target.value)}
                                    variant="outlined"
                                />
                            </Box>


                            {/* <Typography mt={3} variant="subtitle1" fontWeight="bold">
                    {selectedValue
                    ? `You selected: ${
                        smileyOptions.find((o) => o.value === selectedValue).label
                        }`
                    : "Please select a smiley above"}
                </Typography> */}

                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                        <Button type="submit" variant="contained" color="primary" disabled={!selectedValue || view}>Submit Feedback</Button>

                    </DialogActions>
                </Dialog>

            </React.Fragment>
        </ThemeProvider>
    )
}
export default TicketFeedback;